/**
 * store all constant variable with correct dividers
 * use CAPS to declare any constant
 */

/**
 * PROCESS - ENV
 */
export const BACKEND_URL = `${process.env.REACT_APP_BACKEND_URL}/`;

/**
 * COLORS
 */
export const PRIMARY = '#003478';
export const OUTLINE = '#00347880';

/**
 * ROUTES FOR POSP
 */
export const POSP = 'posp';
export const POSP_DETAILS = 'details';
export const POSP_REG = 'register';
export const POSP_TRAINING = 'training';
export const POSP_EXAM = 'exam';
export const POSP_POLICY = 'business/policy';
export const POSP_AGREEMENT = 'training/process-agreement';
export const POSP_LEADS = 'leads';
export const POSP_STATUS = 'status';
export const POSP_CHP = 'chapter';
export const POSP_DASH = 'dashboard';
export const POSP_PRODUCT = 'products';
